import React, { Component } from "react";
import { Container, Row, Col, Card, CardBody, CardHeader, Badge } from "reactstrap";

class StorageService extends Component {
  constructor(props) {
    super(props);
    this.state = {
      services: [
        {
          id: 1,
          name: "Short-Term Storage",
          description: "Temporary storage solution for your goods",
          timeframe: "1-30 days",
          price: "R40 per day",
          features: ["24/7 security", "Climate control", "Easy access"]
        },
        {
          id: 2,
          name: "Medium-Term Storage",
          description: "Storage solution for seasonal inventory or goods",
          timeframe: "1-6 months",
          price: "R35 per day",
          features: ["Volume discounts", "Insurance options", "Inventory management"]
        },
        {
          id: 3,
          name: "Long-Term Storage",
          description: "Long-term warehousing solution for your business",
          timeframe: "6+ months",
          price: "R30 per day",
          features: ["Best value rates", "Advanced inventory system", "Fulfillment services"]
        }
      ]
    };
  }

  componentDidMount() {
    document.title = "Storage Services | QikTruck";
  }

  render() {
    return (
      <React.Fragment>
        
        <section className="section mt-5 pt-4">
          <Container>
            <Row className="mb-5">
              <Col lg={12} className="text-center">
                <h2 className="mb-3">Storage Services</h2>
                <p className="lead">
                  Secure, flexible, and affordable storage solutions for your business needs
                </p>
              </Col>
            </Row>
            
            <Row>
              {this.state.services.map((service) => (
                <Col lg={4} key={service.id} className="mb-4">
                  <Card className="h-100 shadow-sm">
                    <CardHeader className="bg-info text-white">
                      <h4 className="mb-0">{service.name}</h4>
                    </CardHeader>
                    <CardBody>
                      <p>{service.description}</p>
                      <div className="mb-3">
                        <Badge color="primary" className="me-2">{service.timeframe}</Badge>
                        <Badge color="success">{service.price}</Badge>
                      </div>
                      <h6>Features:</h6>
                      <ul>
                        {service.features.map((feature, idx) => (
                          <li key={idx}>{feature}</li>
                        ))}
                      </ul>
                      <div className="text-center mt-4">
                        <button className="btn btn-info">Reserve Space</button>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row>
            
            <Row className="mt-5">
              <Col lg={12}>
                <Card>
                  <CardHeader>
                    <h4 className="mb-0">Our Storage Facilities</h4>
                  </CardHeader>
                  <CardBody>
                    <p>Our state-of-the-art storage facilities offer:</p>
                    <Row className="text-center">
                      <Col md={3} className="mb-4">
                        <div className="p-3">
                          <i className="fa fa-shield-alt fa-3x mb-3 text-info"></i>
                          <h5>24/7 Security</h5>
                          <p className="small">CCTV surveillance and on-site security personnel</p>
                        </div>
                      </Col>
                      <Col md={3} className="mb-4">
                        <div className="p-3">
                          <i className="fa fa-thermometer-half fa-3x mb-3 text-info"></i>
                          <h5>Climate Control</h5>
                          <p className="small">Temperature and humidity controlled environments</p>
                        </div>
                      </Col>
                      <Col md={3} className="mb-4">
                        <div className="p-3">
                          <i className="fa fa-truck-loading fa-3x mb-3 text-info"></i>
                          <h5>Loading Docks</h5>
                          <p className="small">Easy loading and unloading access for all vehicle types</p>
                        </div>
                      </Col>
                      <Col md={3} className="mb-4">
                        <div className="p-3">
                          <i className="fa fa-warehouse fa-3x mb-3 text-info"></i>
                          <h5>Multiple Locations</h5>
                          <p className="small">Conveniently located facilities across major cities</p>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}

export default StorageService; 